// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/aa9012f7345b05f7fecc.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"f99367944f90b6a0d37c","167":"e34aab6d16229a74f4ce","168":"f6fbac581ea8420db785"}[chunkId] + ".chunk.js";
};